// @ts-expect-error no type declarations for superagent-promise
import superagentPromise from 'superagent-promise';
// @ts-expect-error no type declarations for superagent
import _superagent from 'superagent';
import { apiUrl } from '@shared/services/EnvironmentVariables';
import { getSignageToken } from '../storage/signageStorage';

const superagent = superagentPromise(_superagent, Promise);

export class SignageUnauthorizedError extends Error {
  constructor() { super('Signage token rejected'); }
}

// The company switched signage off (or lost the tier); the token itself is
// still valid, so we hold a "disabled" screen instead of re-pairing.
export class SignageDisabledError extends Error {
  constructor() { super('Signage disabled'); }
}

async function makeRequest(method: 'get' | 'post', url: string, body?: any): Promise<any> {
  const fullUrl = `${apiUrl}${url}`;
  const req: any = method === 'get' ? superagent.get(fullUrl) : superagent.post(fullUrl, body);

  const token = getSignageToken();
  if (token) req.set('x-kiosk-token', token);
  req.set('Content-Type', 'application/json');

  try {
    const res = await req;
    return res.body;
  } catch (err: any) {
    if (err && err.response && err.response.statusCode === 401) {
      throw new SignageUnauthorizedError();
    }
    if (err && err.response && err.response.statusCode === 403) {
      throw new SignageDisabledError();
    }
    if (err && err.response && err.response.text) {
      let message = err.response.text;
      try {
        message = JSON.parse(err.response.text).message || message;
      } catch { /* not JSON, use the raw text */ }
      throw new Error(message);
    }
    throw err;
  }
}

export const signageAgent = {
  get: (url: string) => makeRequest('get', url),
  post: (url: string, body?: any) => makeRequest('post', url, body),
};
